import { render, staticRenderFns } from "./ApprovalPage.vue?vue&type=template&id=9063a078&scoped=true"
import script from "./ApprovalPage.vue?vue&type=script&lang=ts"
export * from "./ApprovalPage.vue?vue&type=script&lang=ts"
import style0 from "./ApprovalPage.vue?vue&type=style&index=0&id=9063a078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9063a078",
  null
  
)

export default component.exports